
import $ from 'jquery';
import { Component, Vue } from 'vue-property-decorator';
import Camera from './Camera.vue';

@Component({
  components: {
    Camera,
  },
})
export default class CameraModal extends Vue {
  file: Blob | null = null;
  fileName: string | null = null;

  get canApply(): boolean {
    return !!this.file && !!this.fileName;
  }

  public open(): void {
    $(this.$refs.modal!).modal('show');
    (this.$refs.camera as Camera).startCamera();
  }

  public dismiss(): void {
    (this.$refs.camera as Camera).stopCamera();
    $(this.$refs.modal!).modal('hide');
  }

  apply(): void {
    this.$emit('apply', { fileName: this.fileName, file: this.file });
  }

  onCameraChanged(event: { fileName: string | null, file: Blob | null }) {
    this.file = event.file;
    this.fileName = event.fileName;
  }
}
